<template>
<span>
  <v-text-field
    v-model="modelStart"
    label="Од"
    hide-details
    :disabled="disabled"
    @input="onInput"
    color="teal lighten-2"
    :readonly="readonly" />
  <v-text-field
    v-model="modelEnd"
    label="До"
    hide-details
    @input="onInput"
    :disabled="disabled"
    color="teal lighten-2"
    :readonly="readonly" />
</span>
</template>
<script>
export default {
  name: 'text-range',
  data () {
    return {
      modelStart: this.value,
      modelEnd: ''
    }
  },
  methods: {
    onInput () {
      this.$emit('input', [this.modelStart, this.modelEnd])
    }
  },
  props: {
    value: {},
    label: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
